// resources/js/woocommerce/mini-cart/index.js
import { initPanel, openPanel, bindInside, bindMiniXS } from './panel.js';
import { initCrossSellsAddAll } from './cross-sells-add-all.js';
import { initAjaxAddToCart } from './ajax-add-to-cart.js';
import { els, css } from './dom.js';

function rebindInsideAndSync() {
  bindInside();
  const panel = els.panel();
  if (!panel || panel.getAttribute('aria-hidden') === 'true' || !panel.classList.contains(css.active)) {
    els.overlay()?.classList.remove(css.active);
  }
  if (panel) bindMiniXS(panel);
}

function boot() {
  initPanel();
  initCrossSellsAddAll();
  initAjaxAddToCart();
  rebindInsideAndSync();
}

function wireEvents() {
  if (window.jQuery) {
    const $body = jQuery(document.body);

    $body.on('added_to_cart', function () {
      openPanel();
      $body.trigger('wc_fragment_refresh');
    });

    $body.on('wc_fragments_loaded wc_fragments_refreshed', function () {
      rebindInsideAndSync();
    });
  }

  ['wc_fragments_loaded', 'wc_fragments_refreshed'].forEach(evt => {
    document.addEventListener(evt, rebindInsideAndSync);
  });

  document.addEventListener('added_to_cart', () => {
    openPanel();
    if (window.jQuery) jQuery(document.body).trigger('wc_fragment_refresh');
  });
}

function mount() {
  boot();
  wireEvents();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount, { once: true });
} else {
  mount();
}

export default mount;
